// DO NOT EDIT

import React from 'react'

export default () => (
  <>
  <h1>Rapid Urbanism Explorer: Terms and Conditions</h1>
<p><em>The Rapid Urbanism Explorer is an Augmented Intelligence (AI) Platform to strengthen collaboration
amongst decision makers in developing new urban districts in advanced ways</em>. Rapid iterative virtual
prototyping empowers stakeholders to produce complex urbanization scenarios integrating spatial,
temporal, socioeconomic and environmental parameters in real time. Further info on
<a href="www.RapidUrbanism.com/Explorer-AI">www.RapidUrbanism.com/Explorer-AI</a>.</p>
<h2>Terms of Use</h2>
<p>Please read these terms of use (&quot;terms of use&quot;, &quot;agreement&quot;) carefully before using the
www.RapidUrbanism.com website, including any subdomains hosting versions of the Rapid Urbanism
Explorer (&quot;Explorer&quot;), such as Explorer.RapidUrbanism.com or RUE03.RapidUrbanism.com , (&quot;website&quot;,
&quot;service&quot;) operated by IAUAI gGmbH / Rapid Urbanism alias Matthias Nohn (&quot;us&quot;, &quot;we&quot;, &quot;our&quot;). IAUAI
gGmbH shall be solely responsible for any content related to the Explorer, especially any prototype
(see below) - while Rapid Urbanism alias Matthias Nohn is a service provider to IAUAI, only.</p>
<h2>Conditions of Use</h2>
<p>By using this website, you certify that you have read and reviewed this Agreement and that you agree
to comply with its terms. If you do not want to be bound by the terms of this Agreement, you are
advised to leave the website accordingly. We only grant use and access of this website, its
products, and its services to those who have accepted its terms.</p>
<h2>Demonstration Purpose Only</h2>
<p>This website provides access to an early prototype of the Explorer (&quot;Prototype&quot;) for demonstration
purposes, solely. In contrast, the use for real-life applications shall be considered outside of the
uses permitted under this Agreement. (For exceptions see Option for Real-Life Application .) The
Prototype may not be expected to be fit for real-life applications. Consequently, it shall be
expected that the use of the Prototype for real-life applications (e.g., real urban projects) is
severely risky and potentially harmful. Harm may include but is not limited to loss and/or misuse of
data, or the generation of unfeasible or unsafe scenarios - even though appearing feasible or safe
in the simulation, possibly. Therefore, the use of the Prototype for real-life projects but without
professional support and comprehensive due diligence shall be considered outside of the permitted
terms of use, and we assume no responsibility for liabilities related to misuse.</p>
<h2>Option for Real-Life Application</h2>
<p>Conditional on the combination with professional advisory services, the Prototype may provide the
basis for further development towards the deployment in real-life applications, including but not
limited to urban projects, policy analysis, or education.</p>
<p>If so, any use of the Prototype shall be at the sole risk and full responsibility of the
(compulsory) professional service provider who shall perform due diligence on all aspects of the
project and the Explorer, including but not limited to software and model architectures, parameters
and algorithms, all inputs and outputs, and data security. If so, subject to the terms described
under Intellectual property below, the Explorer shall be installed on a website controlled by the
service provider and - as may be needed - be adapted and further developed to meet the requirements
of the specific case.</p>
<p>IAUAI gGmbH offers the required professional advisory services on demand and against fair
compensation. You are free to procure the services by any other qualified entity.</p>
<h2>Privacy Policy</h2>
<p>Before you continue using our website, we advise you to read our privacy policy regarding our user
data collection. It will help you better understand our practices.</p>
<h2>Age Restriction</h2>
<p>You must be at least 18 (eighteen) years of age before you can use this website. By using this
website, you warrant that you are at least 18 years of age, and you may legally adhere to this
Agreement. We assume no responsibility for liabilities related to age misrepresentation.</p>
<h2>User Accounts</h2>
<p>As a user of this website, you may be asked to register with us and provide private information. You
are responsible for ensuring the accuracy of this information, and you are responsible for
maintaining the safety and security of your identifying information. You are also responsible for
all activities that occur under your account or password.</p>
<h2>Security and Risks</h2>
<p>If you think there are any possible issues regarding the security of your account on the website or
of the website itself, inform us immediately so we may address it accordingly. We reserve all rights
to terminate accounts, edit or remove content and cancel orders at our sole discretion.</p>
<h2>Intellectual Property</h2>
<p>The Rapid Urbanism Explorer is developed by the non-profit Initiative for Advanced Urbanization and
Artificial Intelligence, incorporated as IAUAI gGmbH, in partnership with:</p>
<ul>
<li>
<p>2008-present: The Explorer digitalizes and automatizes patterns of the Rapid Urbanism Framework ,
curated by Matthias Nohn and published under a Creative Commons Attribution Non-Commercial Share
Alike 4.0 International License.</p>
</li>
<li>
<p>2019-2020: An initial feasibility study was supported by the German Federal Ministry of Education
and Research BMBF and developed in collaboration with the Smart City Living Lab at the German
Research Center for Artificial Intelligence DFKI and the Department of Computational Architecture
at Bauhaus University Weimar</p>
</li>
<li>
<p>2020-present: The first Prototype is developed in collaboration with Code the Future (platform
development) and the Design Automation Lab at the National University of Singapore (4D model),
with generous support of The Hilti Foundation and Habitat for Humanity</p>
</li>
</ul>
<h2>Licenses</h2>
<p>This version of the Rapid Urbanism Explorer software is open source published under MIT license. The
following third-party software (with their own specific licenses) is included:</p>
<ul>
<li>Lucky Sheet: MIT</li>
<li>Mobius: MIT</li>
<li><a href="./rue_licenses.csv">CSV of third-party software and licenses</a></li>
</ul>
<h2>Applicable Law</h2>
<p>By visiting this website, you agree that the laws applicable in Berlin, Germany will govern these
terms and conditions, and/or any dispute of any sort that might come between us and you, or its
business partners and associates. You also agree that, by principle, the laws applicable in Berlin,
Germany will be applied in lieu of any potentially conflicting laws.</p>
<h2>Disputes</h2>
<p>Any dispute related in any way to your visit to this website or to products you purchase from us
shall be arbitrated by courts applicable to Berlin, Germany and you consent to exclusive
jurisdiction and venue of such courts.</p>
<h2>Indemnification</h2>
<p>You agree to indemnify us and our affiliates. You also agree to hold us and our affiliates harmless
against any legal claims and any demands that may arise from your use or misuse of our services. We
reserve the right to select our own legal counsel.</p>
<h2>Limitation on Liability</h2>
<p>We are not liable for any damages that may occur to you or any third party because of your use or
misuse of our website.</p>
<h2>Modifications to this Agreement</h2>
<p>We reserve the right to edit, modify, and change this Agreement any time. We shall let you / our
users know of these changes through electronic mail. In lieu of electronic mail, we may update this
information on the webpage and require you / users to confirm your / their agreement with the
revised Agreement before being able to use the website again.</p>
<p>This current Agreement is an understanding between us and you, and it supersedes and replaces all
prior agreements regarding the use of this website.</p>
<h2>Final Provisions</h2>
<p>The ineffectiveness of any one or multiple provisions of this Agreement does not affect the validity
of any other. If so, we shall possess the exclusive right to determine a valid provision, which best
achieves the original purpose of the ineffective provision.</p>

  </>
)